import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { blastKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useValidateBlast = (blastId) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: blastKeys.validate(blastId),
        queryFn: () => axios.post(markUrl('blasts/validate/'), { blast_id: blastId }, additional),
        enabled: !!blastId
    });
};
export default useValidateBlast;
